import { InventorySystemTypes } from './types'

export const GENERATED_SLUG_ID_VENUES_INVENTORY_SYSTEM_TYPES: readonly InventorySystemTypes[] =
  [InventorySystemTypes.Av]
